export const SESSION_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  FINISHED: 'finished',
  READY: 'ready'
}



// WEBPACK FOOTER //
// /dist/src/app/session/session-status.const.ts